<template>
  <div class="carinfo">
    <van-row v-if='showa' class="f-14" @click='showRight'>
      <van-col span="4">认证车型</van-col>
      <van-col class="text-r van-ellipsis" span="18">{{carsType}}</van-col>
      <van-col span="1" offset="1"><van-icon name="arrow" /></van-col>
    </van-row>
    <van-row v-else class="f-14">
      <van-col span="4">认证车型</van-col>
      <van-col class="text-r van-ellipsis" offset="1" span="19">{{carsType}}</van-col>
    </van-row>
    <van-uploader :after-read="uploadTravel" :disabled='!showa'>
      <div class="idcard text-c" :style="'background-image:url('+img.travel+')'">
        <div v-show="travel">
          <img width="40" :src="img.camera">
          <div class="f-15 f-w">添加行驶证照片(必填)</div>
        </div>
      </div>
    </van-uploader>
    <van-uploader :after-read="uploadDriving" :disabled='!showa'>
      <div class="idcard text-c" :style="'background-image:url('+img.driving+')'">
        <div v-show="driving">
          <img width="40" :src="img.camera">
          <div class="f-15 f-w">添加驾驶证照片(必填)</div>
        </div>
      </div>
    </van-uploader>
    <van-checkbox v-if="showa" class="f-12" v-model="checked" checked-color="#F6AB00" icon-size="15">
      我已阅读并同意<span class="c-grod">汽车时间认证车主个人信息保护声明</span>
    </van-checkbox>
    <div v-if='showa' class="text-c">
      <van-button round size="large" :disabled="!checked" @click="updateInfo">提交</van-button>
    </div>
  </div>
</template>
<script>
  import info from '../../../api/member/mycars';
  import { mapState } from 'vuex';
  import { Uploader, Checkbox, CheckboxGroup, Button, Row, Col, Icon } from "vant";
  export default {
    data () {
      return {
        travel:true,
        driving:true,
        checked: false,
        carsType:'请选择',
        showa:true, 
        img:{
          travel: require('../../../assets/img/travel.png'),
          driving: require('../../../assets/img/driving.png'),
          camera: require('../../../assets/img/camera.png'),
          car_card:'',
          driver_card:'',
        }
      }
    },
    computed: {
      ...mapState({
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      if(!Lockr.get('token')) {

        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
              this.$appService.needLogin()
            }
          })
        }
        if(this.source == 1){
         this.$store.commit('param/eqshow', true)
       }else{
        this.$toast('请先登录')
        return false
      }
    }

    if(this.source == 3||this.source == 7) {
      this.$appService.isShowReturn({state: true})
    }

    if(this.$route.params.name) {
      this.carsType=this.$route.params.name
      this.brand_id=this.$route.params.brand_id
      this.car_id=this.$route.params.car_id
      this.car_model_id=this.$route.params.car_model_id
    } else if (this.$route.params.carid) {
      this.audit=this.$route.params.audit
      this.carid=this.$route.params.carid
      this.getCarinfo(this.carid)
      if(this.$route.params.audit=='1'){
        this.showa=false
      }
    }
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    getCarinfo(id){
      info.getCarinfo(id).then(res => {
        if(res.data.state == 1) {
          let info=res.data.data
          this.carsType=info.brand.title+info.car.title+info.car_model.title
          this.brand_id=info.brand.id
          this.car_id=info.car.id
          this.car_model_id=info.car_model.id
          this.img.travel=info.car_card_url
          this.img.car_card=info.car_card
          this.img.driving=info.driver_card_url
          this.img.driver_card=info.driver_card
          this.driving=false
          this.travel=false
        }
      })
    },
    uploadTravel(file) {
      let params = new FormData()
      params.append('img', file.file)
      info.uploadImg(params).then(res => {
        if(res.data.state == 1) {
          this.img.travel=res.data.data.img_url
          this.img.car_card=res.data.data.img
          this.travel=false
        }
      })
    },
    uploadDriving(file) {
      let params = new FormData()
      params.append('img', file.file)
      info.uploadImg(params).then(res => {
        if(res.data.state == 1) {
          this.img.driving=res.data.data.img_url 
          this.img.driver_card=res.data.data.img
          this.driving=false
        }
      })
    },
    updateInfo(){
      let car_card= this.img.car_card
      let driver_card= this.img.driver_card
      if(car_card==''){
        this.$toast('请上传行驶证照片');
        return false
      }
      if(driver_card==''){
        this.$toast('请上传驾驶证照片');
        return false
      }
      let params={
        brand_id:this.brand_id,
        car_id:this.car_id,
        car_model_id:this.car_model_id,
        car_card:this.img.car_card,
        driver_card:this.img.driver_card
      }
      info.updateInfo(params).then(res => {
        if(res.data.state == 1) {
          this.$toast.success('保存成功');
          this.$router.replace({name: 'MyCarAudit'})
        }
      })
    },
    showRight(){
      this.$router.push({
        name: `MyCars`,
        params: {
          show: true
        }
      })
    }
  },
  components: {
    [Uploader.name]:Uploader,
    [Row.name]: Row,
    [Col.name]:Col,
    [Checkbox.name]:Checkbox,
    [CheckboxGroup .name]: CheckboxGroup,
    [Button.name]:Button,
    [Icon.name]:Icon
  }
};
</script>

<style lang="scss">
.carinfo{
  padding: 15px;

  .idcard{
    height: 200px;
    margin-top: 15px;
    border-radius: 10px;
    background-size: 100% 200px;

    img{
      margin-top: 20%;
    }
  }
  .van-uploader{
    width: 100%;

    .van-uploader__input-wrapper{
      width: 100%;
    }
  }
  .f-12{
    margin-top: 15px;

    .c-grod{
      color: #F6AB00;
    }
  }
  .text-c{
    margin-top: 22px;
  }
  .van-button--large{
    width: 90%;
    height: 42px;
    color: #fff;
    line-height: 2;
    background-color: #F6AB00;
  }
  .van-col{
    .van-icon{
      margin-top: 8px;
    }
  }
}
</style>
